(function() {
    'use strict';

    a3_cabin_reports.factory('CourseFactory', CourseFactory);

    /**
     * @memberof CabinReports
     * @ngdoc factory
     * @name CourseFactory
     * @description 
     *   Add, Update, Delete and Get Training Courses.
     * @ngInject
     */
    function CourseFactory(IndexedDBService, GroundDutyFactory, $http, apiUrl) {

        /**
         * Initialize Course
         * @memberof CourseFactory
         */
        function Course() {
            this.Id = null;
        }

        var objType = 'Courses';
        var objCallback = Course;

        var service = {
            setCoursesFromServer: setCoursesFromServer,
            setCoursesToStorage: setCoursesToStorage, //save all courses
            getCourseFromStorage: getCourseFromStorage,
            addCourseToStorage: addCourseToStorage, //update course
            saveOneCourseToStorage: saveOneCourseToStorage, //save course
            getCoursesFromStorage: getCoursesFromStorage, //get all
            updateCourseInfo: updateCourseInfo,
            updateFlightCourseInfo: updateFlightCourseInfo,
            getCoursesFromStorageByIds: getCoursesFromStorageByIds,
            setCourseOutdated: setCourseOutdated,
            upsertCourse : upsertCourse
        };

        /**
         * Get Course By Id
         * @memberof CourseFactory
         * @param {function} callback  
         */
        function getCourseFromStorage(courseId, callback, errorCallback) {
            IndexedDBService.getById(objType, courseId).then(function(result) {
                callback(result);
            }).catch(errorCallback);
        };

        /**
         * Get Courses
         * @memberof CourseFactory
         * @param {function} callback  
         */
        function getCoursesFromStorage(callback, errorCallback) {
            IndexedDBService.getAll(objType).then(function(results) {
                callback(results);
            }).catch(errorCallback);
        };


        /**
         * Get Course By Ids
         * @memberof CourseFactory
         * @param {function} callback  
         */
        function getCoursesFromStorageByIds(courseIds, callback, errorCallback) {
            IndexedDBService.getAll(objType).then(function(results) {
                var selectedResults = [];
                results.forEach(function(result) {
                    if (courseIds.includes(result.Id) && selectedResults.filter(x => x.Id == result.Id).length == 0) {
                        selectedResults.push(result);
                    }
                })
                callback(selectedResults);
            }).catch(errorCallback);
        };

        

        function updateCourseInfo(courseId, dutyId, callback, errorOnSaveCallback, errorOnNetwork) {
            var traingingApiURL = apiUrl + '/Training?courseId=' + courseId + '&dutyId=' + dutyId;
            $http.get(traingingApiURL, { 'Content-Type': 'application/json' })
                .then(function(data) {
                    var course = data.data;
                    course.FetchedTime = moment.utc().toJSON();
                    var duty = GroundDutyFactory.getGroundDutyFromStorage(dutyId);
                    course.FetchedDutyCodes = duty.RelatedGroundDuties.filter(x => !x.IsInstructor).map(x => String(x.GroundDutyNo));
                    course.LastFetchedDutyId = dutyId;
                    //Upsert course in IndexDB 
                    upsertCourse(course, function(course){
                        callback(course);
                    }, errorOnSaveCallback);
                })
                .catch(errorOnNetwork)
        }

        function updateFlightCourseInfo(crewRouteCourse, date, dutyNo, dutyDay, callback, errorOnSaveCallback, errorOnNetwork) {
            var traingingApiURL = apiUrl + '/Training/GetCrewRouteTraining';
            $http.post(traingingApiURL, crewRouteCourse, { 'Content-Type': 'application/json' })
                .then(function(data) {
                    var course = data.data;

                    course.FetchedTime = moment.utc().toJSON();

                    course.FetchedCrewRoute = {
                        date: date,
                        dutyNo: dutyNo,
                        dutyDay: dutyDay
                    };

                    //Upsert course in IndexDB 
                    upsertCourse(course, function(course){
                        callback(course);
                    }, errorOnSaveCallback);
                })
                .catch(errorOnNetwork)
        }

        function upsertCourse(course, callback, errorOnSaveCallback){
             getCourseFromStorage(course.Id, function(localCourse) {
                if (localCourse) {
                    saveOneCourseToStorage(course);
                } else {
                    addCourseToStorage(course);
                }
                callback(course);
            }, errorOnSaveCallback);
        }

        function setCourseOutdated(courseId, callback, errorCallback) {
            getCourseFromStorage(courseId, function(localCourse) {
                if (localCourse) {
                    localCourse.NeedsRefresh = true;
                    saveOneCourseToStorage(localCourse);
                }

                if (callback) {
                    callback();
                }
            }, errorCallback)
        }



        /**
         * Set Courses from server API  
         * @memberof CourseFactory
         * @param {array} courses Courses Object
         * @param {array} courseIdsToSend  Current courses of the storage
         * @param {string} lastSyncDate  Last Sync Date 
         */
        function setCoursesFromServer(courses, callback, errorCallback) {

            getCoursesFromStorage(function(localCourses) {
                // No courses found - Save All Incoming
                if (!localCourses || localCourses.length == 0) {
                    setCoursesToStorage(courses);
                } else {
                    for (var j = 0; j < courses.length; j++) {
                        var IsCourseIncluded = false;

                        for (var h = 0; h < localCourses.length; h++) {
                            if (courses[j].Id == localCourses[h].Id) {
                                IsCourseIncluded = true;
                                break;
                            }
                        }

                        //Update existing course
                        if (IsCourseIncluded) {
                            localCourses[h].Title = courses[j].Title; //Update title from sync
                            saveOneCourseToStorage(localCourses[h]);
                        }
                        //Add a new Course
                        else {
                            addCourseToStorage(courses[j]);
                        }
                    }

                    localCourses.filter(x => !courses.some(z => z.Id == x.Id)).forEach(function(course) {
                        IndexedDBService.remove(objType, course.Id)
                    })
                }
            })

        }

        /**
         * Set Courses
         * @memberof CourseFactory
         * @param {array} Courses A list of courses to set to indexedDB
         */
        function setCoursesToStorage(Courses, callback, errorCallback) {
            IndexedDBService.addAll(objType, Courses).then(callback).catch(errorCallback);
        };

        /**
         * Add Course to Storage
         * @memberof CourseFactory
         * @param {object} Course
         */
        function addCourseToStorage(Course, callback, errorCallback) {
            IndexedDBService.add(objType, Course).then(callback).catch(errorCallback);
        };

        /**
         * Update Course to Storage
         * @memberof CourseFactory
         * @param {object} Course
         */
        function saveOneCourseToStorage(Course, callback, errorCallback) {
            IndexedDBService.put(objType, Course).then(callback).catch(errorCallback);
        };

        return service;
    }

})();